import { convertArrowFromServerModel } from './ArrowServerModel';
import { ContentConverter } from './ContentConverter';
import { ContentTypeServerEnum } from './ContentItem';
import { convertToNavigationRestrictionWithAutoProgress } from './propertiesConverter';
import { convertModalSizeFromServerModel } from './PropertiesServerModel';
import { RestrictionConverter } from './restrictionConverter';
import { SequencedFlowStepHelper } from '../content/SequencedFlowStep';
import { isSection } from '../content/itemTypeguards';
export const convertToStep = (stepServer, parentId) => {
    const convertedContent = ContentConverter.convertToDomainModel(stepServer.content);
    const position = stepServer.position && convertArrowFromServerModel(stepServer.position);
    return SequencedFlowStepHelper.build({
        title: stepServer.title,
        content: convertedContent,
        restriction: convertToNavigationRestrictionWithAutoProgress(stepServer.properties),
        trackingIdentifier: stepServer.trackingIdentifier,
        audioAsset: stepServer.audioAsset,
        id: stepServer.guid,
        referenceIdentifier: stepServer.referenceIdentifier,
        parentId,
        position: position,
        cameraPosition: stepServer.cameraPosition,
        modalSize: convertModalSizeFromServerModel(stepServer.properties),
    });
};
export const convertStepToUpdateServerModel = (item) => {
    return {
        guid: item.id,
        title: item.title,
        content: ContentConverter.convertToServerModel(item.content),
        audioAsset: item.audioAsset,
        properties: {
            navigation: RestrictionConverter.toServerModel(item.restriction),
            modalSize: item.modalSize,
        },
        referenceIdentifier: item.referenceIdentifier,
        position: item.position,
        cameraPosition: item.cameraPosition,
    };
};
export const convertStepToCreateServerModel = (item, parentItem) => {
    const defaultData = {
        ...convertStepToUpdateServerModel(item),
        itemType: ContentTypeServerEnum.SequencedFlowStep,
        trackingIdentifier: item.trackingIdentifier,
    };
    return isSection(parentItem)
        ? {
            ...defaultData,
            parentId: parentItem.id,
        }
        : {
            ...defaultData,
            itemId: parentItem.id,
        };
};
